import CircularProgress from "@mui/material/CircularProgress";

export const ConfirmLoadingIcon = () => (
  <CircularProgress color="inherit" size={16} sx={{ mr: 1 }} />
);
